import { Injectable } from '@angular/core';
import { AnalyticsEvent } from '../../models/analytics/analytics-event.model';

@Injectable()
export abstract class AnalyticsBaseService {
  abstract initialize(config: any): void;
  abstract trackEvent(event: AnalyticsEvent): Promise<void>;
  abstract setUser(userId: string, userProperties?: Record<string, any>): void;
  abstract reset(): void;
}
